var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPageNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.275 11.2998C0.0916668 11.1165 0 10.8831 0 10.5998C0 10.3165 0.0916668 10.0831 0.275 9.8998L4.175 5.9998L0.275 2.0998C0.0916668 1.91647 0 1.68314 0 1.3998C0 1.11647 0.0916668 0.883138 0.275 0.699804C0.458333 0.516471 0.691667 0.424805 0.975 0.424805C1.25833 0.424805 1.49167 0.516471 1.675 0.699804L6.275 5.2998C6.375 5.3998 6.446 5.50814 6.488 5.6248C6.52933 5.74147 6.55 5.86647 6.55 5.9998C6.55 6.13314 6.52933 6.25814 6.488 6.3748C6.446 6.49147 6.375 6.5998 6.275 6.6998L1.675 11.2998C1.49167 11.4831 1.25833 11.5748 0.975 11.5748C0.691667 11.5748 0.458333 11.4831 0.275 11.2998Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNext);
export default __webpack_public_path__ + "static/media/page_next.8fb9400edd6aa8b5b171d636123d176d.svg";
export { ForwardRef as ReactComponent };